
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  inheritAttrs: false,
  components: {}
})
export default class TooltipPop extends Vue {
  @Prop() titleText: string
  @Prop() contentText: string[]

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
